import { useSelector } from 'react-redux';

import { useDisplayError } from 'modules/errors';
import { useOrderSearchParams, useSearchSearchParams } from 'modules/table';

import { selectFilteredAssessmentReports } from '../services/selectors';

import { useFetchAssessmentReports } from '../hooks/useFetchAssessmentReports';

import { DEFAULT_SORT } from '../constants';

export const useAssessmentReports = () => {
    const { search, defaultValue } = useSearchSearchParams();
    const sorting = useOrderSearchParams() ?? DEFAULT_SORT;

    const api = useFetchAssessmentReports();

    const quotations = useSelector(state => selectFilteredAssessmentReports(state, { sorting, search }));

    useDisplayError(api.error);

    return {
        loading: api.inProgress,
        documents: quotations,
        defaultSearch: defaultValue,
    };
};
